import { DropdownSelectable } from 'components/common/dropdown';

interface Props {
  handleChange: (value: string) => void;
  options: { text: string; value: string }[];
  value: string;
}

const TaskDropdownFilter = ({ handleChange, options, value }: Props) => {
  return (
    <DropdownSelectable
      category="lighter"
      defaultValue={value}
      dropdownTextMinWidth="150px"
      onChange={handleChange}
      options={options}
      showArrow={true}
      showSelectedText={true}
      value={value}
    />
  );
};

export default TaskDropdownFilter;
